import Vue from "vue";
import Vuex from "vuex"; 
import {themes} from "./helper";

Vue.use(Vuex);
export const state = {
	title: "",
	snackbar: {
		show: false,
		timeout: -1,
		color: "success",
		message: null,
		onStateChange: false
	},
	loggedInUser: localStorage.getItem("login_user") ?
		JSON.parse(localStorage.getItem("login_user")) : null ,

		Themes:themes
	
		
	
};

export const mutations = {
	setTitle(state, title) {
		state.title = title;
	},
	showSnackbar(state, settings) {
		state.snackbar = {
			show: true,
			timeout: settings.timeout || -1,
			color: settings.color || "success",
			message: settings.message || "",
			onStateChange: settings.onStateChange || false
		};
	},
	hideSnackbar(state) {
		state.snackbar = { message: "", show: false };
	},
	setLoggedInUser(state, loggedInUser) {
		state.loggedInUser = loggedInUser;
	}
};

export const getters = {
	checkUserPrivilege: state => (privilege) => {
		const loggedInUser = state.loggedInUser;
		return loggedInUser &&
			(loggedInUser.isAdmin ||
				(loggedInUser.privileges && loggedInUser.privileges.indexOf(privilege) > -1));
	},
	getThemeById: state => (id) => {
		return state.Themes.find((item) => item.id === id ) || null;
	}
};

export default new Vuex.Store({
	state,
	getters,
	mutations
});